import { render, staticRenderFns } from "./list-churumbela.vue?vue&type=template&id=65b43825"
import script from "./list-churumbela.vue?vue&type=script&lang=js"
export * from "./list-churumbela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports